//Put everything in an IIFE (Immediately-Invoked function expression) to avoid global variables.
(function () {
    "use strict"

    //Default Environment Variable.
    var __env = {};

    //Import Variables if present
    if (window) {
        if (typeof Object.assign != 'function') {
            // Must be writable: true, enumerable: false, configurable: true
            Object.defineProperty(Object,
                "assign",
                {
                    value: function assign(target, varArgs) { // .length of function is 2
                        'use strict';
                        if (target == null) { // TypeError if undefined or null
                            throw new TypeError('Cannot convert undefined or null to object');
                        }

                        var to = Object(target);

                        for (var index = 1; index < arguments.length; index++) {
                            var nextSource = arguments[index];

                            if (nextSource != null) { // Skip over if undefined or null
                                for (var nextKey in nextSource) {
                                    // Avoid bugs when hasOwnProperty is shadowed
                                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                        to[nextKey] = nextSource[nextKey];
                                    }
                                }
                            }
                        }
                        return to;
                    },
                    writable: true,
                    configurable: true
                });
        }
        Object.assign(__env, window.__env);
    }

    angular.module('templates', []);

    try {
        // Ask for a reference to the digestHud module. This will throw if the module hasn't been registered.
        angular.module('digestHud');
    }
    catch (err) {
        // digestHud provider is not registered. We'll register a lightweight fake.
        angular.module('digestHud', [])
            .provider('digestHud', ['$provide', function ($provide) {
                'use strict';
                this.enable = function () { };
                this.$get = function () { };
            }]);
    }

    //Create the app module, with dependency to ngRoute
    var formApp = angular.module('formApp',
        [
            'ngRoute', 
            'ngSanitize', 
            'checklist-model', 
            'ui.bootstrap', 
            'angularFileUpload', 
            'templates', 
            'digestHud', 
            'vcRecaptcha',
            'ui.grid', 
            'ui.grid.selection', 
            'ui.grid.expandable', 
            'ui.grid.autoResize', 
            'AdalAngular'
        ])
        // Track when the application is first loaded
        .run(['$rootScope', function ($rootScope) {
            $rootScope.appJustLoaded = true;
        }]);

}());
